import React, { FC } from 'react';
import s from './stats.module.scss';
import { SocialManagerView } from '@specs/views';
import { useCountFollowers } from '@hooks/TRPC_Hooks/useCountFollowers';
import { useCountFollowing } from '@hooks/TRPC_Hooks/useCountFollowing';
import { NumberLoader } from '@components/NumberLoader/NumberLoader';
import { nFormatter } from '@helpers/helpers';
import { FormattedMessage } from 'react-intl';
interface Props {
  shortid: SocialManagerView.publicProfile['shortid'];
}
export const Stats: FC<Props> = ({
  shortid
}) => {
  const {
    data: followers,
    isLoading: isLoadingFollowers
  } = useCountFollowers({
    shortid
  }, {
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: true
  });
  const {
    data: following,
    isLoading: isLoadingFollowing
  } = useCountFollowing({
    shortid
  }, {
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: true
  });
  return <div className={s.stats} data-sentry-component="Stats" data-sentry-source-file="Stats.tsx">
            <div className={s.stats__item}>
                <FormattedMessage id='public.profile.followers.count' values={{
        count: () => isLoadingFollowers ? <NumberLoader digitCount={3} /> : nFormatter(followers ?? 0, 1)
      }} data-sentry-element="FormattedMessage" data-sentry-source-file="Stats.tsx" />
            </div>
            <div className={s.stats__item}>
                <FormattedMessage id='public.profile.following.count' values={{
        count: () => isLoadingFollowing ? <NumberLoader digitCount={3} /> : nFormatter(following ?? 0, 1)
      }} data-sentry-element="FormattedMessage" data-sentry-source-file="Stats.tsx" />
            </div>
        </div>;
};